(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
  constructor() {
  super();
  }

  connectedCallback() {
  this.header = document.querySelector('.section-header');
  this.announcementBar = document.querySelector('.announcement-bar');
  this.announcementBarHeight = this.announcementBar ? this.announcementBar.offsetHeight : 0;

  this.setHeaderHeight();

  window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

  this.currentScrollTop = 0;

  this.onScrollHandler = this.onScroll.bind(this);
  window.addEventListener('scroll', this.onScrollHandler, false);
  window.addEventListener('resize', this.onResize.bind(this), false);
  }

  setHeaderHeight() {
  document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
  window.removeEventListener('scroll', this.onScrollHandler);
  window.removeEventListener('resize', this.onResize);
  }

  onResize() {
  this.announcementBarHeight = this.announcementBar ? this.announcementBar.offsetHeight : 0;
  }

  onScroll() {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  if (scrollTop > this.announcementBarHeight) {
  this.header.classList.add('scrolled-past-header');
  this.header.classList.add('shopify-section-header-sticky');
  } else {
  this.header.classList.remove('scrolled-past-header');
  this.header.classList.remove('shopify-section-header-sticky');
  }

  this.currentScrollTop = scrollTop;
  }
  }

  customElements.define('sticky-header', StickyHeader);
  
  } catch(e) { console.error(e); }
})();
})();
